import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="w-full py-10 px-4 md:px-10 lgl:px-20">
      <h1 className="text-4xl font-bold text-designColor mb-8">Politique de Confidentialité</h1>
      
      <div className="space-y-6 text-lg">
        <p>Dernière mise à jour : {new Date().toLocaleDateString()}</p>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-designColor">1. Collecte des informations</h2>
          <p>Nous ne collectons aucune information personnelle sur ce site portfolio. Ce site est uniquement destiné à présenter mes travaux et compétences professionnelles.</p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-designColor">2. Utilisation des cookies</h2>
          <p>Ce site utilise des cookies techniques essentiels au fonctionnement du site. Ces cookies ne collectent aucune information personnelle.</p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-designColor">3. Liens externes</h2>
          <p>Ce site peut contenir des liens vers des sites externes. Nous ne sommes pas responsables des pratiques de confidentialité de ces sites.</p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-designColor">4. Contact</h2>
          <p>Pour toute question concernant cette politique de confidentialité, vous pouvez me contacter via LinkedIn.</p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
